var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuilding = function SvgBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M1.333 14.667h13.334M11.333 1.333H4.667C2.667 1.333 2 2.527 2 4v10.667h12V4c0-1.473-.667-2.667-2.667-2.667M4.667 11h2M9.333 11h2M4.667 8h2M9.333 8h2M4.667 5h2M9.333 5h2"
  })));
};
export default SvgBuilding;